<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" fullscreen hide-overlay transition="dialog-bottom-transition" style="height: 94vh !important;">
      <v-card >
        <v-toolbar dark color="primary" style="z-index: 100;">
          <v-btn icon dark @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Instalação</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                v-if="!isFranchisee"
                dark
                text
                @click="dialogRevision = true"
              >
                Adicionar Revisão
              </v-btn>
              <v-btn
                text
                @click="openChoosePdfModal"
                :disabled="loading"
                style="margin-left: 8px;"
              >
                <v-icon>mdi-file-chart-outline</v-icon>
                Relatórios
              </v-btn>
              <v-btn
                dark
                text
                :loading="loading"
                @click="save()"
                :disabled="readonlyScreen"
              >
                <v-icon>mdi-content-save</v-icon>
                Salvar
              </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-dialog v-model="choosePdfModal" max-width="600px" persistent transition="dialog-top-transition">
          <v-card>
            <v-form>
              <v-toolbar color="primary" dark> <span class="text-h5">Escolher Relatório</span></v-toolbar>
              <v-card-title>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text style="padding-bottom: 0;">
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="pdfTermOption"
                      :items="pdfTermOptions"
                      label="Opção do PDF"
                      item-text="name"
                      item-value="id"
                      outlined
                      :loading="pdfLoading"
                      :disabled="pdfLoading"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="pdfTermsWithMultipleOptions.includes(pdfTermOption)">
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="pdfChosenOptionByTerm[pdfTermOption]"
                      :items="pdfOptionsByTerms[pdfTermOption]"
                      label="Qual o tipo do termo?"
                      outlined
                      :loading="pdfLoading"
                      :disabled="pdfLoading"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="pdfChosenOptionByTerm[pdfTermOption] === 'Local'" cols="12">
                    <v-autocomplete
                      v-model="pdfChosenLocalByTerm[pdfTermOption]"
                      :items="pdfLocals"
                      item-text="local"
                      item-value="id"
                      outlined
                      dense
                      chips
                      small-chips
                      label="Qual o local?"
                      :loading="pdfLoading"
                      :disabled="pdfLoading"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeChoosePdfModal" :disabled="pdfLoading">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="downloadPdfModal" :disabled="pdfLoading">Baixar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="pdfDialogDownload" max-width="400">
          <v-card>
            <v-card-title class="headline">Salvar Arquivo</v-card-title>
            <v-card-text>
              Clique abaixo para salvar o arquivo.<br />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a :href="pdfFileLink" download>
                <v-btn color="success" text @click="pdfDialogDownload = false">
                  Salvar Arquivo
                </v-btn>
              </a>
              <v-btn color="error" text @click="pdfDialogDownload = false">
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <!-- Loading overlay -->
        <v-overlay :value="loading" absolute>
          <v-card color="primary" dark class="pa-4">
            <v-card-text class="text-center">
              <v-progress-circular indeterminate size="64" width="6"></v-progress-circular>
              <div class="mt-3">{{ loadingMessage }}</div>
            </v-card-text>
          </v-card>
        </v-overlay>
        
        <v-dialog v-model="is_loading" max-width="320" persistent>
              <v-list class="py-5" color="primary" elevation="12" rounded style="max-height: 400px; overflow-y: auto;">
                <v-list-item class="d-flex justify-space-between">
                  <div>
                    <span style="color: white; font-size: large;">Salvando Instalação...</span>
                  </div>
                  <div>
                    <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
                  </div>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-for="(image, index) in savedImages" :key="index">
                  <v-list-item-content>
                    <v-list-item-title style="color: white;">
                      {{ image.name }} - 100%
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
        </v-dialog>
        <!-- KPIs de Status das Soluções -->
        <v-container fluid class="pa-2">
          <v-row>
            <v-col cols="12">
              <v-card class="mb-2" elevation="1">
                <v-card-title class="text-subtitle-1 primary--text py-2">
                  <v-icon left color="primary" small>mdi-chart-pie</v-icon>
                  Status das Soluções
                  <v-spacer></v-spacer>
                  
                  <!-- Indicador de modificações não salvas -->
                  <v-chip
                    v-if="unsavedModifiedCount > 0"
                    color="warning"
                    dark
                    small
                    class="mr-2"
                  >
                    <v-icon left small>mdi-alert</v-icon>
                    {{ unsavedModifiedCount }} modificado(s)
                  </v-chip>
                  
                  <!-- Indicador de tudo salvo -->
                  <v-chip
                    v-else-if="totalSolutions > 0"
                    color="success"
                    dark
                    small
                    class="mr-2"
                  >
                    <v-icon left small>mdi-check</v-icon>
                    Tudo salvo
                  </v-chip>
                  
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="toggleKpisVisibility"
                        :color="showKpis ? 'primary' : 'grey'"
                      >
                        <v-icon>{{ showKpis ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ showKpis ? 'Ocultar KPIs' : 'Mostrar KPIs' }}</span>
                  </v-tooltip>
                </v-card-title>
                <v-expand-transition>
                  <v-card-text v-show="showKpis" class="pa-3">
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="2">
                        <v-card class="text-center" color="success" dark @click="showStatusDetails('Instalado')" style="cursor: pointer;">
                        <v-card-text class="pa-3">
                          <v-icon size="36" class="mb-1">mdi-check-circle</v-icon>
                          <div class="text-h5 font-weight-bold">{{ statusCounts.instalado }}</div>
                          <div class="text-caption">Instalado</div>
                          <div class="text-caption">Clique para detalhes</div>
                        </v-card-text>
                      </v-card>
                      </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                      <v-card class="text-center" color="warning" dark @click="showStatusDetails('Pendente')" style="cursor: pointer;">
                        <v-card-text class="pa-3">
                          <v-icon size="36" class="mb-1">mdi-clock</v-icon>
                          <div class="text-h5 font-weight-bold">{{ statusCounts.pendente }}</div>
                          <div class="text-caption">Pendente</div>
                          <div class="text-caption">Clique para detalhes</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                      <v-card class="text-center" color="error" dark @click="showStatusDetails('Não se Instala')" style="cursor: pointer;">
                        <v-card-text class="pa-3">
                          <v-icon size="36" class="mb-1">mdi-close-circle</v-icon>
                          <div class="text-h5 font-weight-bold">{{ statusCounts.naoInstalado }}</div>
                          <div class="text-caption">Não Instalado</div>
                          <div class="text-caption">Clique para detalhes</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                      <v-card class="text-center" color="info" dark @click="showStatusDetails('Revisado')" style="cursor: pointer;">
                        <v-card-text class="pa-3">
                          <v-icon size="36" class="mb-1">mdi-eye</v-icon>
                          <div class="text-h5 font-weight-bold">{{ statusCounts.revisado }}</div>
                          <div class="text-caption">Revisado</div>
                          <div class="text-caption">Clique para detalhes</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                      <v-card class="text-center" color="orange" dark @click="showStatusDetails('Não Autorizado')" style="cursor: pointer;">
                        <v-card-text class="pa-3">
                          <v-icon size="36" class="mb-1">mdi-block-helper</v-icon>
                          <div class="text-h5 font-weight-bold">{{ statusCounts.naoAutorizado }}</div>
                          <div class="text-caption">Não Autorizado</div>
                          <div class="text-caption">Clique para detalhes</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                      <v-card class="text-center" color="grey" dark @click="showStatusDetails('Desativado')" style="cursor: pointer;">
                        <v-card-text class="pa-3">
                          <v-icon size="36" class="mb-1">mdi-power-off</v-icon>
                          <div class="text-h5 font-weight-bold">{{ statusCounts.desativado }}</div>
                          <div class="text-caption">Desativado</div>
                          <div class="text-caption">Clique para detalhes</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row class="mt-3">
                    <v-col cols="12">
                      <v-card class="text-center" color="grey lighten-3" elevation="0">
                        <v-card-text class="pa-3">
                          <div class="text-subtitle-1 grey--text text--darken-1">
                            Total: <span class="font-weight-bold primary--text">{{ totalSolutions }}</span> soluções
                          </div>
                          <v-progress-linear
                            :value="progressPercentage"
                            color="primary"
                            height="6"
                            class="mt-2"
                          ></v-progress-linear>
                          <div class="text-caption grey--text mt-1">
                            {{ instaladoPercentage }}% instalado
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  
                  <!-- Informação de Diárias -->
                  <v-row class="mt-2">
                    <v-col cols="12">
                      <v-card class="text-center" color="blue lighten-5" elevation="0">
                        <v-card-text class="pa-2">
                          <div class="d-flex align-center justify-center">
                            <v-icon color="blue" small class="mr-2">mdi-calendar-clock</v-icon>
                            <span class="text-caption blue--text text--darken-2">
                              <strong>{{ diariasUtilizadas }}</strong> diária(s) utilizada(s)
                            </span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  
                  <!-- Gráfico de Timeline -->
                  <v-row class="mt-4" v-if="timelineChartData">
                    <v-col cols="12">
                      <v-card elevation="1">
                        <v-card-title class="text-subtitle-1 primary--text py-2">
                          <v-icon left color="primary" small>mdi-chart-line</v-icon>
                          Evolução dos Status por Data
                        </v-card-title>
                        <v-card-text class="pa-3">
                          <div style="height: 300px; position: relative;">
                            <canvas ref="timelineChart"></canvas>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-expand-transition>
              
              <!-- Resumo quando colapsado -->
              <v-card-text v-show="!showKpis" class="pa-2">
                <v-row align="center" justify="center" no-gutters>
                  <!-- Chips compactos de status -->
                  <v-col cols="12" class="text-center">
                    <v-chip color="success" dark class="ma-1">
                      <v-icon left small>mdi-check-circle</v-icon>
                      {{ statusCounts.instalado }} Instalado
                    </v-chip>
                    <v-chip color="warning" dark class="ma-1">
                      <v-icon left small>mdi-clock</v-icon>
                      {{ statusCounts.pendente }} Pendente
                    </v-chip>
                    <v-chip color="error" dark class="ma-1">
                      <v-icon left small>mdi-close-circle</v-icon>
                      {{ statusCounts.naoInstalado }} Não Instalado
                    </v-chip>
                    <v-chip color="info" dark class="ma-1">
                      <v-icon left small>mdi-eye</v-icon>
                      {{ statusCounts.revisado }} Revisado
                    </v-chip>
                    <v-chip color="orange" dark class="ma-1" v-if="statusCounts.naoAutorizado > 0">
                      <v-icon left small>mdi-block-helper</v-icon>
                      {{ statusCounts.naoAutorizado }} Não Autorizado
                    </v-chip>
                    <v-chip color="grey" dark class="ma-1" v-if="statusCounts.desativado > 0">
                      <v-icon left small>mdi-power-off</v-icon>
                      {{ statusCounts.desativado }} Desativado
                    </v-chip>
                  </v-col>
                </v-row>
                
                <!-- Barra de progresso compacta -->
                <v-row class="mt-2" no-gutters>
                  <v-col cols="12">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <span class="text-caption grey--text">
                        <v-icon x-small color="primary" left>mdi-chart-line</v-icon>
                        Progresso: {{ instaladoPercentage }}%
                      </span>
                      <span class="text-caption grey--text">
                        {{ statusCounts.instalado }}/{{ totalSolutions }} instaladas
                      </span>
                    </div>
                    <v-progress-linear
                      :value="progressPercentage"
                      color="primary"
                      height="6"
                      rounded
                    ></v-progress-linear>
                  </v-col>
                </v-row>
                
                <!-- Informação de Diárias Compacta -->
                <v-row class="mt-1" no-gutters>
                  <v-col cols="12">
                    <div class="d-flex align-center justify-center">
                      <v-icon x-small color="blue" left>mdi-calendar-clock</v-icon>
                      <span class="text-caption blue--text text--darken-2">
                        <strong>{{ diariasUtilizadas }}</strong> diária(s)
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            </v-col>
          </v-row>
        </v-container>
          <v-overlay v-if="readonlyScreen" absolute>
            <div class="readonly-overlay"></div>
          </v-overlay>
          <ConsumptionSolutions 
            ref="ConsumptionSolutions"
            :installationId="idInstallation" 
            :installation="installationData"
            :idProject="idProject"
            @consumption-solution:save="solutionUpdate" 
          />
          <NextStepProject
            style="z-index: 100;"
            :id_project="idProject"
            :loading="is_loading"
            :message="messageNextStep"
            :disabled="disabledButtonNextStep"
            :click="openConfirmFinishDialog"
            @loading="(status) => is_loading = status"
          />
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogAlert"
        persistent
        max-width="500px"
        >    
        <v-card color="primary"> 
          <v-card-title style="color: white">
            <v-icon color="yellow darken-2" left>mdi-alert</v-icon>
            Aviso
            <v-spacer></v-spacer>            
          </v-card-title>
          <v-card-text style="color: white">    
              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <span style="font-weight: bold; font-size: 1.1em;">Resumo das soluções não salvas</span>
              </div>
              <div style="max-height: 220px; overflow-y: auto;" v-if="localStorageData && localStorageData.consumptionHistoric && localStorageData.consumptionHistoric.filter(sol => sol.isModified).length > 0">
                <v-simple-table dense style="background: transparent; color: white;">
                  <thead>
                    <tr >
                      <th>Local</th>
                      <th>Sub-local</th>
                      <th>Status</th>
                      <th>Qtd</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sol, idx) in localStorageData.consumptionHistoric.filter(sol => sol.isModified)" :key="idx">
                      <td>{{ sol.local || '-' }}</td>
                      <td>{{ sol.sub_local || '-' }}</td>
                      <td>{{ sol.status || '-' }}</td>
                      <td>{{ sol.amountSolution || '-' }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
              <v-divider class="my-2"/>
            Existem informações que não foram salvas, deseja recuperar esses dados?
          </v-card-text>
          <v-card-actions >
            <v-spacer></v-spacer> 
            <v-btn
              color="white"
              text
              @click="getLocalStorage()"
            >
              Confirmar
            </v-btn>
            <v-btn
              color="white"
              text
              @click="cancelGetLocalStorage()"
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfirmDeleteLocal"
      persistent
      max-width="400px"
    >
      <v-card color="primary">
        <v-card-title style="color: white">
          <v-icon color="red lighten-2" left>mdi-alert</v-icon>
          Atenção
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text style="color: white">
          Se você prosseguir, os dados locais não salvos serão <b>permanentemente excluídos</b> e não poderão ser recuperados. Tem certeza que deseja continuar?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="confirmDeleteLocal">Sim, excluir</v-btn>
          <v-btn color="white" text @click="cancelDeleteLocal">Voltar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para detalhes dos status -->
    <v-dialog
      v-model="dialogStatusDetails"
      max-width="1000px"
    >
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left :color="getStatusColor(selectedStatus)">{{ getStatusIcon(selectedStatus) }}</v-icon>
          Detalhes - {{ selectedStatus }}
          <v-spacer></v-spacer>
          <v-chip color="primary" dark small>
            {{ filteredSolutionsByStatus.length }} solução(ões)
          </v-chip>
          <v-btn icon @click="exportStatusDetails" :disabled="!filteredSolutionsByStatus.length">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon @click="dialogStatusDetails = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="statusDetailsHeaders"
            :items="filteredSolutionsByStatus"
            :items-per-page="15"
            :loading="!solutionsData.length"
            loading-text="Carregando dados das soluções..."
            class="elevation-1"
          >
            <template v-slot:item.local="{ item }">
              {{ item.local }}
            </template>
            <template v-slot:item.sub_local="{ item }">
              {{ item.sub_local }}
            </template>
            <template v-slot:item.type="{ item }">
              {{ convertNameType(item.type) }}
            </template>
            <template v-slot:item.solution="{ item }">
              {{ convertSolutionName(item.solution) }}
            </template>
            <template v-slot:item.amountSolution="{ item }">
              {{ item.amountSolution || '-' }}
            </template>
            <template v-slot:item.comments="{ item }">
              {{ item.comments || '-' }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfirmFinish"
      persistent
      max-width="400px"
    >
      <v-card color="primary">
        <v-card-title style="color: white">
          <v-icon color="green lighten-2" left>mdi-check-circle</v-icon>
          Confirmação
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text style="color: white">
          Ao finalizar a instalação, o projeto será enviado para análise de um especialista.
          Você realmente terminou a instalação das soluções?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="confirmFinishInstallation">Sim, finalizar</v-btn>
          <v-btn color="white" text @click="dialogConfirmFinish = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogRevision"
      transition="dialog-top-transition"
      max-width="600"
    >
      <v-card>
        <v-toolbar color="primary" dark>Revisar Instalação</v-toolbar>
        <v-card-text>
          <v-col cols="12">
            <v-radio-group row v-model="revisionStatus">
              <v-radio label="Aprovado" value="approved" color="green" />
              <v-radio label="Revisão" value="revision" />
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-textarea
                v-model="revisionObservation"
                label="Explique o motivo da decisão, se necessário..."
                outlined
              />
            </v-row>
          </v-col>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogRevision = false">Cancelar</v-btn>
          <v-btn text @click="saveRevision">Salvar Revisão</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Installation from "./Installation.js";
export default Installation;
</script>

<style scoped>
::v-deep .v-dialog.v-dialog--fullscreen {
  height: 94vh !important;
}
</style>